module.exports = __webpack_public_path__ + "img/Skirt-Front-B3-Da-Gc-Ha-Ia.26deb863.png";